import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlatSelectComponent } from './flat-select.component';

@NgModule({
  declarations: [
    FlatSelectComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FlatSelectComponent,
  ]
})
export class FlatSelectModule { }
